import { render } from "./FixtureHeader.vue?vue&type=template&id=234fa584"
import script from "./FixtureHeader.vue?vue&type=script&lang=js"
export * from "./FixtureHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__